function TeacherWelcome(): JSX.Element {
    return (
        <div>
            <span>Lisätietoa VIKKE-hankkeesta: </span>
            <a href="https://vikke.nmi.fi/" target="_blank" rel="noopener noreferrer" className="font-bold text-teal-500">https://vikke.nmi.fi/</a>
        </div>
    );
}

export default TeacherWelcome;